import validate from "/tmp/tmp2la0xefc/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/tmp/tmp2la0xefc/middleware/redirect.global.ts";
import manifest_45route_45rule from "/tmp/tmp2la0xefc/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}